"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReferralLink = void 0;
// The app runs on a HashRouter: anything outside the "#" never reaches the router.
// Derived from the live address, not BASE_URL — the env files disagree on whether it has a "#".
function buildReferralLink(referralCode) {
    var baseUrl = "".concat(window.location.origin).concat(window.location.pathname);
    return "".concat(baseUrl, "#/home?referral_code=").concat(encodeURIComponent(referralCode));
}
exports.buildReferralLink = buildReferralLink;
